
import { Assessment } from '@/types/assessment';
import { mapDbAssessmentToModel } from '@/services/supabaseUtils';
import { createServiceClient } from '@/services/migration/serviceClient';

// Get all assessments
export const getAssessments = async (): Promise<Assessment[]> => {
  try {
    // Use service client to bypass RLS policies
    const serviceClient = createServiceClient();
    
    const { data: dbAssessments, error } = await serviceClient
      .from('assessments')
      .select('*');
      
    if (error) {
      console.error('Error fetching assessments:', error);
      throw error;
    }
    
    // Map database assessments to app model
    const assessments = await Promise.all(
      dbAssessments.map(dbAssessment => mapDbAssessmentToModel(dbAssessment))
    );
    
    return assessments;
  } catch (error) {
    console.error('Error in getAssessments:', error);
    throw error;
  }
};

// Get assessment by ID
export const getAssessmentById = async (id: string): Promise<Assessment | null> => {
  try {
    // Use service client to bypass RLS policies
    const serviceClient = createServiceClient();
    
    const { data: dbAssessment, error } = await serviceClient
      .from('assessments')
      .select('*')
      .eq('id', id)
      .single();
      
    if (error || !dbAssessment) {
      console.error('Error fetching assessment:', error);
      return null;
    }
    
    // Map database assessment to app model
    return await mapDbAssessmentToModel(dbAssessment);
  } catch (error) {
    console.error('Error in getAssessmentById:', error);
    return null;
  }
};

// Get assessment by slug
export const getAssessmentBySlug = async (slug: string): Promise<Assessment | null> => {
  try {
    // Use service client to bypass RLS policies
    const serviceClient = createServiceClient();
    
    const { data: dbAssessment, error } = await serviceClient
      .from('assessments')
      .select('*')
      .eq('slug', slug)
      .single();
      
    if (error || !dbAssessment) {
      console.error('Error fetching assessment by slug:', error);
      return null;
    }
    
    // Map database assessment to app model
    return await mapDbAssessmentToModel(dbAssessment);
  } catch (error) {
    console.error('Error in getAssessmentBySlug:', error);
    return null;
  }
};
